import React, { useEffect, useRef } from "react";
import "../styles/layout/OurServices.scss";
import { Typography, Container, Box, Paper, Button } from "@mui/material";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const printRef = useRef(null);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Container
        className="ourservicespage"
        style={{
          backgroundColor: "#FFC3EA",
          height: "auto",
          maxWidth: "100%",
          padding: "0",
          margin: "0",
          display: "flex",
          flexDirection: "column",
          gap: "2%",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            flex: "1",
            fontFamily: "Orbitron",
            fontSize: { xs: "24px", sm: "40px", md: "70px" }, // Responsive font size
            fontWeight: "800",
            color: "#000",
            letterSpacing: "2px",
            justifyContent: "center",
            padding: { xs: "8px", sm: "4%" }, // Responsive padding
            textAlign: "center", // Center alignment for smaller screens
          }}
        >
          Privacy Policy for Tecloq
        </Typography>

        <Box
          sx={{
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "81px 110px",
            gap: "10px",
            height: "500px",
            background: "#FFFFFF",
            border: "3px solid #000000",
            overflow: "hidden",
            margin: "0 8% 5% 8%",
          }}
        >
          <Box
            ref={printRef}
            className="printContent"
            sx={{
              width: "110%",
              height: "100%",
              overflowY: "auto",
              scrollbarColor: "#F005A2 transparent", // Pink scrollbar for Firefox
              "&::-webkit-scrollbar": {
                width: "20px", // Scrollbar width
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent", // Track background color
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#F005A2", // Pink scrollbar handle
                borderRadius: "50px", // Rounded edges
                minHeight: "80px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#F005A2", // Darker pink on hover
              },
              "&::-webkit-scrollbar-button": {
                display: "none", // Hides scrollbar arrows
                background: "transparent",
              },
            }}
          >
            {/* <Paper elevation={0} sx={{ margin: "0 10% 0 10%" }}>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "lighter",
                  textAlign: "center",
                }}
              >
                Tecloq (“we,” “our,” or “us”) is committed to protecting the
                privacy of our users and clients. This Privacy Policy outlines
                how we collect, use, and safeguard your information when you
                interact with our website, services, or platforms. By accessing
                our services, you agree to the practices described in this
                policy.
              </Typography>
              <Typography sx={styles.heading}>
                1. Information We Collect
              </Typography>
              <Typography sx={styles.bodyText}>
                We may collect the following types of information:
                <ul>
                  <li>
                    Personal Information: Name, email address, phone number, and
                    other details you provide when contacting us or registering
                    for our services.
                  </li>
                  <li>
                    Technical Information: IP address, browser type, operating
                    system, and other details collected via cookies and
                    analytics tools.
                  </li>
                  <li>
                    Usage Data: Information about how you interact with our
                    website and services.
                  </li>
                </ul>
              </Typography>
              <Typography sx={styles.heading}>
                2. How We Use Your Information
              </Typography>
              <Typography sx={styles.bodyText}>
                We use the information we collect to:
                <ul>
                  <li>
                    Provide, manage, and improve our AI and Data Analytics
                    services.
                  </li>
                  <li>Respond to inquiries and provide customer support.</li>
                  <li>
                    Send updates, newsletters, or promotional materials (with
                    your consent).
                  </li>
                  <li>Ensure website security and monitor usage trends.</li>
                </ul>
              </Typography>
              <Typography sx={styles.heading}>
                3. Sharing of Information
              </Typography>
              <Typography sx={styles.bodyText}>
                We do not sell or rent your information to third parties.
                However, we may share your information with:
                <ul>
                  <li>
                    Service Providers: Trusted third-party vendors who assist in
                    delivering our services.
                  </li>
                  <li>
                    Legal Obligations: Authorities when required to comply with
                    legal obligations or protect our rights.
                  </li>
                </ul>
              </Typography>
              <Typography sx={styles.heading}>
                4. Cookies and Tracking Technologies
              </Typography>
              <Typography sx={styles.bodyText}>
                Our website uses cookies to enhance user experience and analyze
                website traffic. You can manage or disable cookies through your
                browser settings.
              </Typography>
              <Typography sx={styles.heading}>5. Data Security</Typography>
              <Typography sx={styles.bodyText}>
                We implement industry-standard measures to protect your data
                against unauthorized access, loss, or misuse. However, no method
                of transmission or storage is 100% secure.
              </Typography>
              <Typography sx={styles.heading}>6. Your Rights</Typography>
              <Typography sx={styles.bodyText}>
                As a user, you have the right to:
                <ul>
                  <li>Access, update, or delete your personal information.</li>
                  <li>Withdraw consent where applicable.</li>
                  <li>Opt-out of receiving marketing communications.</li>
                </ul>
                To exercise your rights, please contact us at
                support@tecloqservices.com
              </Typography>
              <Typography sx={styles.heading}>7. Retention of Data</Typography>
              <Typography sx={styles.bodyText}>
                We retain your information only as long as necessary to fulfill
                the purposes outlined in this policy or as required by law.
              </Typography>
              <Typography sx={styles.heading}>8. Third-Party Links</Typography>
              <Typography sx={styles.bodyText}>
                Our website may contain links to third-party websites. We are
                not responsible for the privacy practices or content of these
                external sites.
              </Typography>
              <Typography sx={styles.heading}>9. Policy for Minors</Typography>
              <Typography sx={styles.bodyText}>
                Our services are not intended for individuals under 18 years of
                age. We do not knowingly collect personal information from
                minors.
              </Typography>
              <Typography sx={styles.heading}>
                10. Updates to This Privacy Policy
              </Typography>
              <Typography sx={styles.bodyText}>
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page, and the “Last Updated” date will be
                revised.
              </Typography>
              <Typography sx={styles.heading}>11. Contact Us</Typography>
              <Typography sx={styles.bodyText}>
                If you have any questions or concerns about this Privacy Policy,
                please contact us at:
                <ul>
                  <li>Email: support@tecloqservices.com</li>
                  <li>
                    Address: 1-5-1119/117/3/402, Ashray Avenue Block,
                    Pakalakunta, Old Alwal, Alwal, Hyderabad, Telangana-500010
                  </li>
                </ul>
                Your trust is important to us, and we are committed to
                safeguarding your privacy.
              </Typography>
            </Paper> */}
            <Paper
              elevation={0}
              sx={{
                margin: { xs: "5%", sm: "0 10%" },
                padding: { xs: "5%", sm: "3%" },
                fontFamily: "Inter",
                color: "#000",
              }}
            >
              {/* Intro */}
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  textAlign: "center",
                  marginBottom: "5%",
                }}
              >
                Tecloq (“we,” “our,” or “us”) is committed to protecting the
                privacy of our users and clients. This Privacy Policy outlines
                how we collect, use, and safeguard your information when you
                interact with our website, services, or platforms. By accessing
                our services, you agree to the practices described in this
                policy.
              </Typography>

              {/* Section 1 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                1. Information We Collect
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                We may collect the following types of information:
                <ul>
                  <li>
                    Personal Information: Name, email address, phone number, and
                    other details you provide when contacting us or registering
                    for our services.
                  </li>
                  <li>
                    Technical Information: IP address, browser type, operating
                    system, and other details collected via cookies and
                    analytics tools.
                  </li>
                  <li>
                    Usage Data: Information about how you interact with our
                    website and services.
                  </li>
                </ul>
              </Typography>

              {/* Section 2 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                2. How We Use Your Information
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                We use the information we collect to:
                <ul>
                  <li>
                    Provide, manage, and improve our AI and Data Analytics
                    services.
                  </li>
                  <li>Respond to inquiries and provide customer support.</li>
                  <li>
                    Send updates, newsletters, or promotional materials (with
                    your consent).
                  </li>
                  <li>Ensure website security and monitor usage trends.</li>
                </ul>
              </Typography>

              {/* Section 3 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                3. Sharing of Information
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                We do not sell or rent your information to third parties.
                However, we may share your information with:
                <ul>
                  <li>
                    Service Providers: Trusted third-party vendors who assist in
                    delivering our services.
                  </li>
                  <li>
                    Legal Obligations: Authorities when required to comply with
                    legal obligations or protect our rights.
                  </li>
                </ul>
              </Typography>

              {/* Section 4 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                4. Cookies and Tracking Technologies
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                Our website uses cookies to enhance user experience and analyze
                website traffic. You can manage or disable cookies through your
                browser settings.
              </Typography>

              {/* Section 5 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                5. Data Security
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                We implement industry-standard measures to protect your data
                against unauthorized access, loss, or misuse. However, no method
                of transmission or storage is 100% secure.
              </Typography>

              {/* Section 6 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                6. Your Rights
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                  marginBottom: "2%",
                }}
              >
                You have the right to:
                <ul>
                  <li>Access, update, or delete your personal information.</li>
                  <li>Withdraw consent where applicable.</li>
                  <li>Opt-out of receiving marketing communications.</li>
                </ul>
                To exercise your rights, please contact us at
                support@tecloqservices.com.
              </Typography>

              {/* Section 7 */}
              <Typography
                sx={{
                  fontSize: { xs: "18px", sm: "24px" },
                  fontWeight: "700",
                  marginBottom: "2%",
                }}
              >
                7. Contact Us
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  fontWeight: "400",
                  lineHeight: { xs: "140%", sm: "160%" },
                }}
              >
                If you have any questions or concerns about this Privacy Policy,
                please contact us at:
                <ul>
                  <li>Email: support@tecloqservices.com</li>
                  <li>
                    Address: 1-5-1119/117/3/402, Ashray Avenue Block,
                    Pakalakunta, Old Alwal, Alwal, Hyderabad, Telangana-500010
                  </li>
                </ul>
                Your trust is important to us, and we are committed to
                safeguarding your privacy.
              </Typography>
            </Paper>
          </Box>
        </Box>
        {/* <Button onClick={() => window.print()} style={{display:"flex" ,width: "150.84px", height: "52.23px", backgroundColor: "#F005A2", borderRadius: "45.25px", opacity: "100%", alignItems:"center", justifyContent:"center", padding:"0 2% 0 2%", textDecoration:"none", color:"inherit", marginBottom:"5%"}}>
                <div style={{fontFamily:"Poppins", fontSize:"18px", letterSpacing:"8%", fontWeight:"700", textTransform: "none"}}>
                Print
                </div>
            </Button> */}
        <style>
          {`
            @media print {
                body * {
                visibility: hidden; /* Hide everything by default */
                }
                .printContent, .printContent * {
                visibility: visible; /* Show only the scrollable content */
                }
                .printContent {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: auto;
                overflow: visible; /* Expand content fully */
                }
            }
            `}
        </style>
      </Container>
    </Box>
  );
};

const styles = {
  bodyText: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "lighter",
    textAlign: "left",
  },
  heading: {
    fontFamily: "Orbitron",
    fontSize: "25px",
    fontWeight: "800",
    textAlign: "center",
    padding: "3% 0 3% 0",
  },
};

export default PrivacyPolicy;
